import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterLogo>
            <LogoText>FreakIT</LogoText>
            <LogoSubtext>혁신적인 교육 솔루션</LogoSubtext>
          </FooterLogo>
          <FooterDescription>
            IT와 교육의 결합을 통해 더
            나은 학습 경험을 제공합니다.
          </FooterDescription>
        </FooterSection>

        <FooterSection>
          <FooterTitle>제품</FooterTitle>
          <FooterLink to="/socra">SOCRATEST - AI 구술시험</FooterLink>
          <FooterLink to="/hura">HuRA - AI HR 역량평가</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>사이드 프로젝트</FooterTitle>
          <FooterLink to="/projects/aristo">ARISTO - AI 튜터링</FooterLink>
          <FooterLink to="/kaistudy">KAIStudy - 그룹과외</FooterLink>
          <FooterLink to="/projects/vta">VTA - 가치관 유형 검사</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>회사</FooterTitle>
          <FooterLink to="/about">회사 소개</FooterLink>
          <FooterLink to="/achievements">성과</FooterLink>
          <FooterLink to="/contact">문의하기</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>연락처</FooterTitle>
          {/* 변경된 정보 */}
          <FooterText>Email: freakit2025@gmail.com</FooterText>
          <FooterText>Phone: +82 10-7568-3302</FooterText>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <Copyright>
          © {new Date().getFullYear()} FreakIT. All rights reserved.
        </Copyright>
        <FooterLinks>
          <FooterBottomLink to="/privacy">개인정보처리방침</FooterBottomLink>
        </FooterLinks>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  background: rgba(2, 6, 23, 0.8);
  backdrop-filter: blur(20px);
  color: white;
  padding: 4rem 2rem 2.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

const FooterContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
`;

const LogoText = styled.h2`
  font-size: 1.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 0%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.02em;
`;
const LogoSubtext = styled.span`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: -0.25rem;
`;
const FooterDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  font-size: 0.9rem;
`;
const FooterTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;
const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  transition: ${({ theme }) => theme.transitions.fast};
  &:hover {
    color: ${({ theme }) => theme.colors.accent};
    padding-left: 0.5rem;
  }
`;
const FooterText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  line-height: 1.6;
`;
const FooterBottom = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
`;
const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const FooterBottomLink = styled(Link)`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;